export const environment = {
  msalConfig: {
    auth: {
      tenantId: 'b5fc2c61-76a2-40e2-ba4e-e12c0967b898',
      clientId: '8b05197b-00ec-4ae0-ac55-849521b27181',
      // tenantId: '209b0c4b-2e35-4dd4-be38-9ef718a27019',
      // clientId: '710bfd04-e84d-41f5-94ea-a2fd56f4eec4',
    },
  },
};
